import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../app-exc-progbar/app-exc-progbar.component';
import {ExcIndicatorData} from '../app-exc-indicator/app-exc-indicator.component';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ExcSigninService} from 'exc-signin';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {DefaultSettingsService} from '../default-settings-service.service';
import {DealerActionService} from '../dealer-action-service.service';
import {AuditActionService} from '../audit-action-service.service';
import {ModalNewLocationComponent} from '../modals/modal-new-location/modal-new-location.component';
import {GeofenceComponent} from '../geofence/geofence.component';
import {ReportService} from '../report-service.service';
import {
  ModalDealerBlackWhiteListComponent
} from '../modals/modal-dealer-black-white-list/modal-dealer-black-white-list.component';
import {DatePipe} from '@angular/common';
import {ModalDealerSuccessorComponent} from '../modals/modal-dealer-successor/modal-dealer-successor.component';

@Component({
  selector: 'app-dealer-details',
  templateUrl: './dealer-details.component.html',
  styles: []
})
export class DealerDetailsComponent extends ExcTranslation implements OnInit, OnDestroy, IExcTab {
  @ViewChild('menuPopup') menuPopup;
  Data: any;
  dealer = {
    Header: {} as any,
    Audits: [] as any[],
    Charts: null,
    RecentAudits: [] as any[],
    Hierarchy: [] as any[],
    Defaults: {} as any,
    CurrentStock: [] as any[],
    Locations: [] as any[],
    Auditors: [] as any[],
    Contacts: [] as any[]
  };
  tabinstance: any;
  contactlistconfig: ExcListConfig = new ExcListConfig();
  auditlistconfig: ExcListConfig = new ExcListConfig();
  hierarchyListconfig: ExcListConfig = new ExcListConfig();
  currentStockListconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  level = 1;
  searchValue: string = null;
  searchValueLocations: string = null;
  stockSearchValue: string = null;
  selectedStock: [] = [];
  locationsListconfig: ExcListConfig = new ExcListConfig();
  isLoading = true;
  dateNow = Date.now();

  private isDestroyed = false;

  constructor(
    private excRest: ExcRestService,
    private excSec: ExcSigninService,
    private excDss: DefaultSettingsService,
    private das: DealerActionService,
    private aas: AuditActionService,
    private reportService: ReportService,
    public datePipe: DatePipe) {
    super();
    const _self = this;

    _self.contactlistconfig.selectionMode = 'none';

    _self.auditlistconfig.selectionMode = 'none';
    _self.auditlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.auditlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.auditlistconfig.paging.pagingPage = pageNo;
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnRefresh = () => {
      _self.reloadAudits();
    };
    _self.auditlistconfig.OnDownload = () => {
      _self.exportAuditList();
    };
    _self.auditlistconfig.OnDetailLink = (item) => {
      new ExcTab(_self.dealer.Header['DealerName'] + ' - ' + item.AuditID, AuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          _self.reloadAudits();
        }
      }, true).Open();
    };

    if (_self.excSec.isFeatured('CLI_ADT_C')) {
      _self.auditlistconfig.OnAdd = () => {
        this.aas.Create(_self.dealer.Header, _self.dealer.Auditors).subscribe(ret => {
          _self.reloadAudits();
        });
      };
    }

    _self.currentStockListconfig.selectionMode = 'multi';
    _self.currentStockListconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.currentStockListconfig.OnSearch = function (searchValue, event?) {
      _self.stockSearchValue = searchValue || '';
      _self.loadStock();
    };
    _self.currentStockListconfig.OnPageChanged = (pageNo, event1) => {
      _self.currentStockListconfig.paging.pagingPage = pageNo;
      _self.loadStock();
    };
    _self.currentStockListconfig.OnRefresh = () => {
      _self.loadStock();
    };
    _self.currentStockListconfig.OnSelectionChanged = (selecteditems, event) => {
      _self.selectedStock = selecteditems;
    };

    _self.hierarchyListconfig.selectionMode = 'none';
    _self.hierarchyListconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.hierarchyListconfig.OnSearch = function (searchValue, event?) {
      _self.searchValue = searchValue || '';
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnPageChanged = (pageNo, event1) => {
      _self.hierarchyListconfig.paging.pagingPage = pageNo;
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnRefresh = () => {
      _self.reloadHierarchy();
    };
    _self.hierarchyListconfig.OnDetailLink = (item, event?) => {
      new ExcTab(item.DealerName, DealerDetailsComponent, item, item.DealerID, {
        Unique: true, ReloadParent: function () {
        }
      }, true).Open();
    };

    if (_self.excSec.isFeatured('CLI_DLR_CU')) {
      _self.locationsListconfig.OnAdd = () => {
        _self.openLocationDialog(_self.dealer.Header, null);
      };
      _self.locationsListconfig.OnDelete = (selectedItems)  => {
        _self.deleteLocations(selectedItems);
      };
    }

    _self.locationsListconfig.paging = {pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.locationsListconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueLocations = searchValue || '';
      _self.reloadLocations();
    };
    _self.locationsListconfig.OnPageChanged = (pageNo, event1) => {
      _self.locationsListconfig.paging.pagingPage = pageNo;
      _self.reloadLocations();
    };
    _self.locationsListconfig.OnRefresh = () => {
      _self.reloadLocations();
    };
  }

  ngOnInit() {
    this.dateNow = Date.now();
    this.initialLoad();
  }

  ngOnDestroy() {
    this.isDestroyed = true;
  }

  reloadDealerHeader(callback?: () => void) {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerR_Summary', {DealerID: _self.Data.DealerID});
    const mi = _self.auditlistconfig.GetMetaInfo();

    mi.dataSort = {'AuditPlanFlt': 'desc'};

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret && ret.data && ret.data.Header) {
        _self.dealer.Header = ret.data.Header;

        if (ret.data.Defaults) {
          _self.dealer.Defaults = {};
          for (const df of ret.data.Defaults) {
            _self.dealer.Defaults[df.DefaultField] = [];
            for (const v of df.Items) {
              _self.dealer.Defaults[df.DefaultField].push(v.Value);
            }
          }
        }
      }

      if (callback) {
        callback();
      }
    });
  }

  editDealer() {
    if (!this.excSec.isFeatured('CLI_DLR_CU')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }

    const _self = this;

    _self.reloadDealerHeader(() => {
      ExcCoreModule.showModal(ModalDealerEditComponent, null, 'm-alt', _self.dealer.Header, true).subscribe(r => {
        if (r && r.proceed) {
          r.dealer['DealerUPT'] = _self.dealer.Header['DealerUPT'];

          const url = _self.excRest.computeUrl('DealerU', {DealerID: _self.Data.DealerID});
          const mi = _self.auditlistconfig.GetMetaInfo();
          mi.dataSort = {AuditPlanMonth: 'desc'};

          /*
           * DealerU liefert hier teilweise null zurück.
           * Deshalb nicht ret.data verwenden.
           */
          _self.excRest.post(url, r.dealer, {MetaInfo: mi}).subscribe(() => {
            ExcCoreModule.call('Dealer_Reload');

            _self.reloadDealerHeader();
            _self.reloadAudits();
            _self.reloadHierarchy();
            _self.loadStock();
          });
        }
      });
    });
  }

  handleEditComment() {
    const _self = this;
    this.das.Comment(this.dealer.Header['DealerID'], this.dealer.Header['DealerUPT'], this.dealer.Header['DealerComment'])
      .subscribe(ret => {
        Object.assign(_self.dealer.Header, ret.Data);
      });
  }

  handleEditInternalComment() {
    const _self = this;
    this.das.InternalComment(this.dealer.Header['DealerID'], this.dealer.Header['DealerUPT'], this.dealer.Header['DealerCommentInternal'])
      .subscribe(ret => {
        Object.assign(_self.dealer.Header, ret.Data);
      });
  }

  reloadAudits() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerAuditR_List', {DealerID: this.Data.DealerID, fts: this.searchValue == null ? '' : this.searchValue});
    const mi = this.auditlistconfig.GetMetaInfo();
    mi.dataSort = {'AuditPlanFlt': 'desc'};
    _self.auditlistconfig.isLoading = true;

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret) {
        _self.dealer.Audits = ret.data;
        _self.auditlistconfig.paging = ret.paging;
      }

      _self.auditlistconfig.isLoading = false;
    });
  }

  reloadLocations() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerLocationR_List', {DealerID: _self.Data.DealerID, fts: _self.searchValueLocations == null ? '' : this.searchValueLocations});
    const mi = this.locationsListconfig.GetMetaInfo();
    mi.dataSort = {'LocationName': 'asc'};
    _self.locationsListconfig.isLoading = true;

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret) {
        _self.dealer.Locations = ret.data;
        _self.locationsListconfig.paging = ret.paging;
      }

      _self.locationsListconfig.isLoading = false;
    });
  }

  loadStock() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerInventoryR_List', {DealerID: this.Data.DealerID, fts: this.stockSearchValue == null ? '' : this.stockSearchValue});
    const mi = this.currentStockListconfig.GetMetaInfo();
    _self.currentStockListconfig.isLoading = true;

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret) {
        _self.dealer.CurrentStock = ret.data.CurrentStock;
        _self.currentStockListconfig.paging = ret.paging.CurrentStock;
      }

      _self.currentStockListconfig.isLoading = false;
    });
  }

  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerR_Summary', {DealerID: this.Data.DealerID});
    const mi = this.auditlistconfig.GetMetaInfo();
    mi.dataSort = {AuditPlanMonth: 'desc'};

    _self.isLoading = true;
    _self.auditlistconfig.isLoading = true;
    _self.hierarchyListconfig.isLoading = true;
    _self.currentStockListconfig.isLoading = true;

    mi.dataSort = {'AuditPlanFlt': 'desc'};

    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret) {
        _self.dealer = ret.data;
        _self.dealer.Defaults = {};

        for (const df of ret.data.Defaults) {
          _self.dealer.Defaults[df.DefaultField] = [];
          for (const v of df.Items) {
            _self.dealer.Defaults[df.DefaultField].push(v.Value);
          }
        }

        _self.locationsListconfig.paging = ret.paging.Locations;
        _self.auditlistconfig.paging = ret.paging.Audits;
        _self.hierarchyListconfig.paging = ret.paging.Hierarchy;
        _self.currentStockListconfig.paging = ret.paging.CurrentStock;
      }

      _self.currentStockListconfig.isLoading = false;
      _self.auditlistconfig.isLoading = false;
      _self.hierarchyListconfig.isLoading = false;
      _self.isLoading = false;
    });
  }

  pickedCheck() {
    const preselected = {mode: 'STOCK', items: []};
    for (const x of this.selectedStock) {
      preselected.items.push(x['InventoryVIN']);
    }

    const _self = this;
    this.aas.Create(this.dealer.Header, this.dealer.Auditors, preselected).subscribe(ret => {
      _self.reloadAudits();
    });
  }

  openLocationDialog(Dealer, data: any) {
    const _self = this;
    let loc = {};

    if (data === null ) {
      loc = null;
    } else {
      Object.assign(loc, data);
      loc['IsEdit'] = true;
    }

    ExcCoreModule.showModal(ModalNewLocationComponent, null, 'm',
      {Dealer: Dealer, Data: loc}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        if (data === null) {
          const url = _self.excRest.computeUrl('DealerLocationC', {DealerID: Dealer.DealerID});
          _self.excRest.post(url, {
            LocationName: ret.location.LocationName,
            LocationStreet: ret.location.LocationStreet,
            LocationZip: ret.location.LocationZip,
            LocationCity: ret.location.LocationCity,
            LocationCountry: ret.location.LocationCountry,
            LocationIsApproved: ret.location.LocationIsApproved,
            LocationIsBusiness: ret.location.LocationIsBusiness
          }, {}).subscribe(obj => {
            if (_self.isDestroyed) {
              return;
            }

            if (obj) {
              _self.reloadLocations();
            }
          });
        } else {
          const url = _self.excRest.computeUrl('DealerLocationU', {DealerID: Dealer.DealerID});
          _self.excRest.put(url, {
            LocationID: ret.location.LocationID,
            LocationName: ret.location.LocationName,
            LocationStreet: ret.location.LocationStreet,
            LocationZip: ret.location.LocationZip,
            LocationCity: ret.location.LocationCity,
            LocationCountry: ret.location.LocationCountry,
            LocationIsApproved: ret.location.LocationIsApproved,
            LocationIsBusiness: ret.location.LocationIsBusiness
          }, {}, false).subscribe(obj => {
            if (_self.isDestroyed) {
              return;
            }

            if (obj) {
              Object.assign(data, obj.data[0]);
            }
          });
        }
      }
    });
  }

  deleteLocations(selectedItems) {
    const _self = this;
    const requests = [];

    selectedItems.forEach(item => {
      requests.push(_self.excRest.delete(_self.excRest.computeUrl('DealerLocationD' , {DealerID: _self.dealer.Header['DealerID'],  LocationID: item.LocationID }),
        {
          DealerID: item.DealerID,
          LocationID: item.LocationID
        }, {}, false).subscribe(response => {
        _self.reloadLocations();
      }));
    });
  }

  openGeofence() {
    const _self = this;
    new ExcTab(_self.dealer.Header['DealerName'], GeofenceComponent, {Header: _self.dealer.Header, Locations: _self.dealer.Locations}, _self.dealer.Header['DealerID'], {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }

  exportAuditList() {
    const _self = this;
    const url = this.excRest.computeUrl('DealerAuditR_export', {DealerID:  _self.dealer.Header['DealerID'], cult: _self.translateService.currentLang});
    _self.excRest.sget(url, ExcCoreModule.Guid.NewGuid(), {}).subscribe(response => {
    });
  }

  reloadHierarchy() {
    const _self = this;
    const url = _self.excRest.computeUrl('DealerHierarchyR_List', {DealerID: _self.Data.DealerID, fts: _self.searchValue == null ? '' : _self.searchValue});
    _self.hierarchyListconfig.isLoading = true;

    _self.excRest.get(url, {MetaInfo: this.hierarchyListconfig.GetMetaInfo()}).subscribe(ret => {
      if (_self.isDestroyed) {
        return;
      }

      if (ret) {
        _self.dealer.Hierarchy = ret.data;
        _self.hierarchyListconfig.paging = ret.paging;
      }

      _self.hierarchyListconfig.isLoading = false;
    });
  }

  showReports(event) {
    const _self = this;
    _self.menuPopup.hide(event);
    _self.reportService.ShowModal('Dealer', _self.Data.DealerID).subscribe(x => {});
  }

  showDealerSuccessor(event) {
    if (!this.excSec.isFeatured('ADDFUDEALER')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    if (this.dealer.Header.DealerSuccessor) {
      return;
    }

    this.menuPopup.hide(event);

    ExcCoreModule.showModal(
      ModalDealerSuccessorComponent,
      null,
      'm',
      {
        DealerID: this.Data.DealerID
      },
      true
    ).subscribe(r => {
      if (r && r.proceed) {
        this.excRest.post(
          this.excRest.computeUrl('DealerSuccessorC', {
            DealerID: this.Data.DealerID
          }),
          {
            Comment: r.Comment,
            MdtHdlrID_New: r.MdtHdlrID_New,
            MdtHdlrID_Old: this.Data.DealerID
          },
          {}
        ).subscribe(ret => {
          if (this.isDestroyed) {
            return;
          }
          if (ret && ret.success) {
            this.reloadDealerHeader();
            this.reloadAudits();
            this.reloadHierarchy();
            this.loadStock();
          }
        });
      }
    });
  }

  editWhitBlackList(addToWhiteList = false, addToBlackList = false) {
    if (!this.excDss.MandantConfig.confDealerInventoryWhiteBlack) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }

    ExcCoreModule.showModal(
      ModalDealerBlackWhiteListComponent,
      null,
      'xxl',
      {
        dealer: [this.dealer.Header],
        addToWhiteList: addToWhiteList ? this.selectedStock : [],
        addToBlackList: addToBlackList ? this.selectedStock : [],
        selectedTab: addToBlackList ? 1 : 0
      },
      true
    ).subscribe(r => {
      if (r && r.proceed) {
        this.excRest.post(
          this.excRest.computeUrl('DealerWhiteBlackListCU', {}),
          {
            dealerList: r.dealerListJSON,
            whiteList: r.whiteListJSON,
            blackList: r.blackListJSON
          },
          {}
        ).subscribe(ret => {
          if (this.isDestroyed) {
            return;
          }

          if (ret && ret.WhiteBlackList) {
            this.dealer.Header.dlrIWBWhiteList = ret.WhiteBlackList[0].dlrIWBWhiteList;
            this.dealer.Header.dlrIWBBlackList = ret.WhiteBlackList[0].dlrIWBBlackList;
            this.loadStock();
          }
        });
      }
    });
  }

  showMenuPopup(event) {
    this.menuPopup.show(event);
  }

  hideMenuPopup(event) {
    this.menuPopup.hide(event);
  }
}
